import React from 'react';
import '../modern.css';
import PageLayout from './PageLayout';
import SectionHeading from './SectionHeading';
import ContentCard from './ContentCard';
import useReveal from '../useReveal';
import { pageContent } from './pageContent';

function AgenticAI() {
  useReveal();
  const cards = pageContent.agents.cards;
  return (
    <PageLayout
      pageKey="agents"
      heroVisual={
        <div className="hero-agents" aria-hidden="true">
          <div className="hero-agents__bar">
            <span className="ag-tag">agent_run.live</span>
            <span className="ag-status">
              <span className="ag-status__item ag-status__item--exec"><i />Executing</span>
              <span className="ag-status__item ag-status__item--done"><i />Delivered</span>
            </span>
          </div>

          <div className="hero-agents__body">
            <div className="ag-objective">
              <span className="ag-objective__text">objective: triage 12,000 invoices</span>
            </div>

            <div className="ag-orchestrator">
              <i className="ag-orch-dot" />
              Orchestrator
            </div>

            <svg className="ag-fan" viewBox="0 0 400 34">
              <line x1="200" y1="4" x2="68" y2="30" />
              <line x1="200" y1="4" x2="200" y2="30" />
              <line x1="200" y1="4" x2="332" y2="30" />
              <circle className="ag-packet ag-packet--out" style={{ '--tx': '-132px', '--ty': '26px', fill: '#e11d48' }} cx="200" cy="4" r="2.6" />
              <circle className="ag-packet ag-packet--out" style={{ '--tx': '0px', '--ty': '26px', fill: '#d97706' }} cx="200" cy="4" r="2.6" />
              <circle className="ag-packet ag-packet--out" style={{ '--tx': '132px', '--ty': '26px', fill: '#16a34a' }} cx="200" cy="4" r="2.6" />
            </svg>

            <div className="ag-lanes">
              <div className="ag-agent" style={{ '--lc': '#be123c', '--lc-soft': 'rgba(225,29,72,0.3)', '--lc-tint': 'rgba(225,29,72,0.05)', '--cd': '0s' }}>
                <span className="ag-agent__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <ellipse cx="12" cy="5" rx="8" ry="3" />
                    <path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5" />
                    <path d="M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
                  </svg>
                </span>
                <span className="ag-agent__name">Knowledge</span>
                <span className="ag-agent__act">
                  <span className="ag-dots"><i /><i /><i /></span>
                  <svg className="ag-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="4 12.5 9.5 18 20 6" />
                  </svg>
                </span>
              </div>

              <div className="ag-agent" style={{ '--lc': '#b45309', '--lc-soft': 'rgba(217,119,6,0.32)', '--lc-tint': 'rgba(217,119,6,0.05)', '--cd': '0.45s' }}>
                <span className="ag-agent__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="16 18 22 12 16 6" />
                    <polyline points="8 6 2 12 8 18" />
                  </svg>
                </span>
                <span className="ag-agent__name">Process</span>
                <span className="ag-agent__act">
                  <span className="ag-dots"><i /><i /><i /></span>
                  <svg className="ag-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="4 12.5 9.5 18 20 6" />
                  </svg>
                </span>
              </div>

              <div className="ag-agent" style={{ '--lc': '#15803d', '--lc-soft': 'rgba(22,163,74,0.32)', '--lc-tint': 'rgba(22,163,74,0.05)', '--cd': '0.9s' }}>
                <span className="ag-agent__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </span>
                <span className="ag-agent__name">Assurance</span>
                <span className="ag-agent__act">
                  <span className="ag-dots"><i /><i /><i /></span>
                  <svg className="ag-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="4 12.5 9.5 18 20 6" />
                  </svg>
                </span>
              </div>
            </div>

            <svg className="ag-converge" viewBox="0 0 400 30">
              <line x1="68" y1="2" x2="200" y2="27" />
              <line x1="200" y1="2" x2="200" y2="27" />
              <line x1="332" y1="2" x2="200" y2="27" />
              <circle className="ag-packet ag-packet--in" style={{ '--tx': '132px', '--ty': '25px', fill: '#e11d48' }} cx="68" cy="2" r="2.6" />
              <circle className="ag-packet ag-packet--in" style={{ '--tx': '0px', '--ty': '25px', fill: '#d97706' }} cx="200" cy="2" r="2.6" />
              <circle className="ag-packet ag-packet--in" style={{ '--tx': '-132px', '--ty': '25px', fill: '#16a34a' }} cx="332" cy="2" r="2.6" />
            </svg>

            <div className="ag-gate">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <polyline points="8.5 11.5 11 14 15.5 9" />
              </svg>
              <span>Guardrails &middot; human oversight &middot; EU AI Act</span>
            </div>

            <div className="ag-outcome">
              <svg className="ag-outcome__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <polyline className="ag-outcome-path" points="4 12.5 9.5 18 20 6" />
              </svg>
              <span className="ag-outcome__text">
                <strong>Delivered</strong>
                <em>Full audit trail attached</em>
              </span>
              <span className="ag-outcome__metric">12,000 &#10003;</span>
            </div>
          </div>

          <div className="hero-agents__foot">
            <span className="ag-caption">Every step logged &middot; oversight built in</span>
          </div>
        </div>
      }
    >

      <section className="section" id="difference">
        <SectionHeading {...pageContent.agents.sections.difference} />
        <div className="spectrum-grid">
          {cards.difference.map((card) => (
            <ContentCard
              key={card.stage}
              className="spectrum-card"
              stage={card.stage}
              title={card.title}
              description={card.description}
              items={card.items}
            />
          ))}
        </div>
      </section>

      <section className="section" id="services">
        <SectionHeading {...pageContent.agents.sections.help} />
        <div className="service-grid">
          {cards.help.map((card) => (
            <ContentCard
              key={card.title}
              className="service-card"
              title={card.title}
              description={card.description}
              items={card.items}
            />
          ))}
        </div>
      </section>

      <section className="section section--alt">
        <SectionHeading {...pageContent.agents.sections.standards} />
        <div className="pitch-grid">
          {cards.standards.map((card) => (
            <ContentCard
              key={card.title}
              className="pitch-card"
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </section>

      <section className="section">
        <SectionHeading {...pageContent.agents.sections.work} />
        <div className="methodology-steps">
          {cards.work.map((card, index) => (
            <ContentCard
              key={card.title}
              className="step"
              stepNumber={index + 1}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </section>

      <section className="section section--alt" id="engagement">
        <SectionHeading {...pageContent.agents.sections.engagement} />
        <div className="engagement-grid">
          {cards.engagement.map((card) => (
            <ContentCard
              key={card.title}
              className={`engagement-card ${card.featuredBadge ? 'featured' : ''}`.trim()}
              title={card.title}
              price={card.price}
              featuredBadge={card.featuredBadge}
              description={card.description}
              items={card.items}
              ctaLabel={card.ctaLabel}
              ctaHref={card.ctaHref}
              ctaClassName={card.ctaClassName}
            />
          ))}
        </div>
      </section>

    </PageLayout>
  );
}

export default AgenticAI;
